import { getChildCompanies } from "api/getChildCompanies";
import { getCompanyGroupUsers, IUser } from "api/getCompanyGroupUsers";
import { IUserDetails } from "api/getUserById";
import { ResearchStaffLevelEnum, IResearchReferenceData } from "./types";

const hasResearchStaffLevel = (
  user: IUser
): user is IUser & { researchStaffLevel: ResearchStaffLevelEnum } =>
  user.researchStaffLevel !== null && user.researchStaffLevel !== undefined;

export const getResearchReferenceData = async (
  currentUser: IUserDetails
): Promise<IResearchReferenceData> => {
  const companyScope = currentUser.researchStaffEligible
    ? currentUser.companyId
    : undefined;
  const staff = await getCompanyGroupUsers(companyScope, "ACTIVE", true);
  const teamCompanyId = currentUser.researchStaffEligible
    ? currentUser.companyId
    : staff.objects.find((user) => user.researchStaffEligible)?.companyId;
  const clients = teamCompanyId
    ? await getChildCompanies(teamCompanyId, "ACTIVE")
    : [];

  return {
    clients: clients.map(({ id, name }) => ({ id, name })),
    staff: staff.objects.filter(hasResearchStaffLevel).map((user) => ({
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      level: user.researchStaffLevel,
    })),
  };
};
